import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
// import config from '../../config'
import {GET_TESTIMONIALS} from './actionTypes'
import fetchData, {fetchContent} from '../../utils/fetch-data'
// import {getCookie} from '../../utils/cookie'
// import getCityAliasAPI from '../../utils/get-city-alias-api'

// const homePage = (process.env.NODE_ENV === 'development') ?
//   false : window.theme.isHomePage
// const groupName = !homePage ? window.theme.cityAlias : false

const devEnv = process.env.NODE_ENV === 'development'



// const groupName = !homePage ? window.theme.cityAlias : false

const cityAliasName = () => {
  if (devEnv) {
    return 'chicagodowntown'
  }
  return window.theme.cityAlias
}

const useTestimonialsActions = () => {
  const dispatch = useDispatch()
  const getTestimonials = useCallback(
    async (baseUrlAlias) => {
      // const cityDataJson = await getCityAliasAPI()
      // const baseUrlAlias = cityDataJson.length > 0 ? cityDataJson[0].baseUrlAlias : 'ny'

      dispatch({
        type: GET_TESTIMONIALS,
        payload: baseUrlAlias ?
          await fetchData(`/${baseUrlAlias}/get-testimonials`) :
          await fetchData(`/${cityAliasName()}/get-testimonials`),
      })
    },
    [dispatch],
  )

  return {getTestimonials}
}

export default useTestimonialsActions

